import { tsValidateArray, tsValidateBoolean, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_NoteTemplate } from '@app/advisor-content-shared';
const Validator_MandatoryPropsAdvisorConfiguration = {
    label: tsValidateString(),
    contextRuleIds: tsValidateArray(tsValidateString(), false),
    organizationId: tsValidateString(),
    kbVersionId: tsValidateUniqueId,
    enableSurvey: tsValidateBoolean(),
    devInstance: tsValidateBoolean(),
    enableDocumentation: tsValidateBoolean(),
    enableAgl: tsValidateBoolean(),
    useEhrOrderId: tsValidateBoolean(),
    magicWand: tsValidateBoolean(),
    catchUp: {
        vitals: tsValidateBoolean(),
        recap: tsValidateBoolean(),
    },
    aglFixing: {
        labs: {
            enabled: tsValidateBoolean(),
            suffix: tsValidateString(undefined, false),
        },
        radiology: {
            enabled: tsValidateBoolean(),
            suffix: tsValidateString(undefined, false),
        }
    },
    noteIds: tsValidateArray(tsValidateUniqueId),
};
const Validator_GeneratedProps = {};
export const DBDef_AdvisorConfiguration = {
    modifiablePropsValidator: Validator_MandatoryPropsAdvisorConfiguration,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'advisor-configurations',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'advisor-configurations'
    },
    backend: {
        name: 'advisor-configurations'
    },
    entityName: 'Advisor Configurations',
    dependencies: {
        contextRuleIds: {
            dbKey: 'context-rule',
            fieldType: 'string[]',
        },
        organizationId: {
            dbKey: 'organizations',
            fieldType: 'string',
        },
        kbVersionId: {
            dbKey: 'artifacts',
            fieldType: 'string'
        },
        noteIds: {
            dbKey: DBDef_NoteTemplate.dbKey,
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map